import React from 'react';
import './ContactForm.scss';

import { motion } from 'framer-motion';

import { homePage } from '../../../editable-stuff/config';
import GradientButton from '../../../Library/GradientButton/GradientButton';

import GooglePartner from '../../../assets/img/top-google.svg';
import DigitalNetworkAgency from '../../../assets/img/digital-network-agency.svg';
import Awwwards from '../../../assets/img/top-awwwards.svg';
import Csswinner from '../../../assets/img/top-csswinner.svg';
import Clutch from '../../../assets/img/top-clutch.svg';
import CssDesignAwards from '../../../assets/img/css-design-awards.svg';

export default function ContactForm() {
  return (
    <section id='contact-form' className='p-150 bg-light'>
      <div className='wave-top'>
        <svg
          fill='#fff'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1000 300'
          preserveAspectRatio='none'
        >
          <path d='M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z'></path>
          <path d='M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z'></path>
          <path d='M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z'></path>
        </svg>
      </div>
      <div className='container'>
        <div className='row justify-content-between'>
          <div className='col-12 col-sm-7'>
            <motion.h3
              initial={{ x: '-100px', opacity: 0 }}
              whileInView={{ x: '0', opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              {homePage?.contactUs?.title}
            </motion.h3>
            <motion.div
              className='content'
              initial={{ x: '-100px', opacity: 0 }}
              whileInView={{ x: '0', opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              {homePage?.contactUs?.sub_title}
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className='form mt-8'
            >
              <form method='POST' id='contact-form-section'>
                <GradientTextField
                  type='text'
                  id='name'
                  name='clientname'
                  placeholder="What's your name? *"
                  required={true}
                  className='field half'
                />
                <GradientTextField
                  type='text'
                  id='company'
                  name='company'
                  placeholder='Your company (if applicable)'
                  className='field half'
                />
                <GradientTextField
                  type='email'
                  id='email'
                  name='email'
                  placeholder='Enter your email *'
                  required={true}
                  className='field half'
                />
                <GradientTextField
                  type='tel'
                  id='tel'
                  name='tel'
                  placeholder='Enter your phone number *'
                  required={true}
                  className='field half'
                />
                <div className='field full'>
                  <textarea
                    id='message'
                    name='message'
                    aria-label='Enter your message here'
                    placeholder='Enter your message here...'
                    rows={4}
                  ></textarea>
                </div>
                <div className='full'>
                  <label>Send us your brief (if applicable)</label>
                  <input
                    type='file'
                    id='file'
                    name='clientbrief'
                    aria-label='Brief or project files'
                    accept='image/png, image/jpeg, .doc, .docx, .pdf, .ppt, .pptx'
                  />
                  <span>
                    Accepted file types: jpg, png, pdf, doc, ppt, docx.
                  </span>
                </div>
                <div className='full'>
                  <p>
                    <small>
                      This form collects your contact information so that we can
                      correspond with you. Check out our{' '}
                      <a href='#' target='_blank'>
                        privacy policy
                      </a>{' '}
                      for more information about how we protect and manage your
                      data.
                    </small>
                  </p>
                </div>
                <input type='hidden' name='url' value='$' />
                <GradientButton
                  text='Send Your Enquiry'
                  link='#'
                  svg='send'
                  noMarginTop
                />
              </form>
            </motion.div>
          </div>
          <div className='col-12 col-sm-4'>
            <motion.div
              className='links'
              initial={{ x: '100px', opacity: 0 }}
              whileInView={{ x: '0', opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <p>
                <span>Tel:</span> (+44){' '}
                <a href='tel:+442078705794' className='gradient'>
                  0207 870 5794
                </a>
              </p>
              <p>
                <span>Tel:</span> +1{' '}
                <a href='tel:+12123727640' className='gradient'>
                  (212) 372 7640
                </a>
              </p>
              <p>
                <span>Email:</span>{' '}
                <a
                  href={`mailto:${homePage?.contactUs?.email}`}
                  className='gradient'
                >
                  {homePage?.contactUs?.email}
                </a>
              </p>
            </motion.div>
            <motion.div
              className='logos mt-5'
              initial={{ x: '100px', opacity: 0 }}
              whileInView={{ x: '0', opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <img
                loading='lazy'
                src={GooglePartner}
                alt='google partner'
                style={{ maxWidth: '100px' }}
                width='100'
                height='50'
              />
              <img
                loading='lazy'
                src={DigitalNetworkAgency}
                alt='digital agency logo'
                className='mt-5'
                width='150'
                height='50'
              />
              <img
                loading='lazy'
                src={Awwwards}
                alt='awwwards logo'
                style={{ maxWidth: '120px' }}
                className='mt-3'
                width='120'
                height='50'
              />
              <img
                loading='lazy'
                src={Csswinner}
                alt='css winners'
                style={{ maxWidth: '130px' }}
                className='mt-3'
                width='130'
                height='50'
              />
              <img
                loading='lazy'
                src={Clutch}
                alt='clutch logo'
                style={{ maxWidth: '80px' }}
                className='mt-3'
                width='80'
                height='50'
              />
              <img
                loading='lazy'
                src={CssDesignAwards}
                alt='css design awards logo'
                style={{ maxWidth: '140px' }}
                className='mt-3'
                width='140'
                height='50'
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}

interface GradientTextFieldProps {
  type: string;
  id: string;
  name: string;
  placeholder: string;
  required?: boolean;
  className: string;
}

const GradientTextField = ({
  type,
  id,
  name,
  placeholder,
  required,
  className,
}: GradientTextFieldProps) => {
  return (
    <div className={`${className}`}>
      <input
        type={type}
        id={id}
        name={name}
        aria-label={placeholder}
        required={required}
        placeholder={placeholder}
      />
    </div>
  );
};
